import { render, staticRenderFns } from "./BranchProviderEditor.vue?vue&type=template&id=28433234&scoped=true&"
import script from "./BranchProviderEditor.vue?vue&type=script&lang=js&"
export * from "./BranchProviderEditor.vue?vue&type=script&lang=js&"
import style0 from "./BranchProviderEditor.vue?vue&type=style&index=0&id=28433234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28433234",
  null
  
)

export default component.exports